import { Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store';
import { trainingActionCreators } from '../../store/Training';
import { InterpretValue } from '../../types/TrainingTypes';
import { interpretActionCreators } from './../../store/Interpret';
import InterpretAssess from './InterpretAssess';

export default function Interpret() {
    const trainingState = useAppSelector(state => state.training);
    const state = useAppSelector(state => state.interpret);
    const dispatch = useAppDispatch();

    let borderColor = undefined;
    const reviews = trainingState.card?.resultInfo?.reviews;
    if (reviews && reviews >= 700)
        borderColor = '#001dda';
    else if (reviews && reviews >= 600)
        borderColor = '#4400da';
    else if (reviews && reviews >= 500)
        borderColor = '#9e00da';
    else if (reviews && reviews >= 400)
        borderColor = '#da0092';
    else if (reviews && reviews >= 300)
        borderColor = '#da0000';
    else if (reviews && reviews >= 200)
        borderColor = '#da6400'
    else if (reviews && reviews >= 100)
        borderColor = '#c5a900';

    function getHint() {
        dispatch(interpretActionCreators.showHint());
    }

    function showExample() {
        dispatch(interpretActionCreators.toggleExample());
    }

    function showSolution() {
        dispatch(interpretActionCreators.showSolution());
    }

    function assess(assessmentValue: InterpretValue) {
        dispatch(trainingActionCreators.interpretAssess(assessmentValue));
        dispatch(trainingActionCreators.nextCard());
    };

    function toggleExample() {
        dispatch(interpretActionCreators.toggleExample());
    }

    return (
        <>
            <div className="flex-grow-1 w-100 width-limit d-flex flex-column text-break">
                <div className="interpret-box">
                    <div className="training-box mb-2 mb-sm-3"
                        style={{ borderColor: borderColor }}>
                        <div>
                            <span className="task">{state.task}</span>
                            {state.taskAux &&
                                <>
                                    <br />
                                    <span className="text-secondary"> {state.taskAux}</span>
                                </>
                            }
                        </div>
                    </div>

                    {(state.example || state.taskForms) &&
                        <div className="training-box mb-2 mb-sm-3" onDoubleClick={toggleExample}>
                            {(state.example && (trainingState.isSolutionShown || state.isExampleShown))
                                ?
                                <div className="example">
                                    <span style={{ whiteSpace: 'pre-wrap' }}>{state.example}</span>
                                </div>
                                :
                                state.taskForms
                                    ?
                                    <div>
                                        <span className="text-secondary">{state.taskForms}</span>
                                    </div>
                                    :
                                    <></>
                            }
                        </div>
                    }

                    <div className="training-box mb-2">
                        <div className="solution">
                            <span style={{ whiteSpace: 'pre-wrap' }}>{state.maskedSolution}</span>
                            {state.maskedSolutionAux &&
                                <span className="text-secondary"> {state.maskedSolutionAux}</span>
                            }
                            {state.maskedSolutionForms &&
                                <span className="text-secondary"> {state.maskedSolutionForms}</span>
                            }
                        </div>
                    </div>
                </div>

                {!trainingState.isSolutionShown ?
                    <div className="width-limit">
                        <div className="row g-2 g-sm-3">
                            {!state.example ?
                                <div className="col-12">
                                    <Button variant="light"
                                        size="lg"
                                        onClick={getHint}>
                                        Hint
                                    </Button>
                                </div>
                                :
                                <div className="col-12">
                                    <Button variant="light"
                                        size="lg"
                                        onClick={showExample}
                                        disabled={!((!state.isExampleShown && state.example) || (state.isExampleShown && state.taskForms))}
                                        className="px-1">
                                        {state.isExampleShown && state.taskForms ?
                                            <>Show forms</>
                                            :
                                            <>Show example</>
                                        }
                                    </Button>
                                </div>
                            }
                            <div className="col-12">
                                <Button variant="light"
                                    size="lg"
                                    onClick={showSolution}>
                                    Show meaning
                                </Button>
                            </div>
                        </div>
                    </div>
                    :
                    <InterpretAssess assess={assess} />
                }
                {trainingState.isSolutionShown && state.similar &&
                    <ul className="list-unstyled mt-2 mb-0 fs-5">
                        {state.similar.map(x =>
                            <li key={x.id}><span className="fw-bold">
                                {x.phrase}</span>{x.dictionaryName ? ` (${x.dictionaryName})` : ``} - {x.meaning}
                            </li>
                        )}
                    </ul>
                }
            </div >
        </>
    );
}
